module.exports = __webpack_public_path__ + "img/smw-library11.9839c25f.jpg";